import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="#FFF" stroke="#979593" strokeMiterlimit="10" d="M23.086 2.5H9.5a1 1 0 00-1 1v25a1 1 0 001 1h19a1 1 0 001-1V8.914a1 1 0 00-.293-.707l-5.414-5.414a1 1 0 00-.707-.293z"/>
        <path fill="none" stroke="#979593" strokeMiterlimit="10" d="M23.5 2.5v5a1 1 0 001 1h5"/>
        <path d="M26.5 15h-11a.5.5 0 010-1h11a.5.5 0 010 1zm0 2h-11a.5.5 0 010-1h11a.5.5 0 010 1zm0 2h-11a.5.5 0 010-1h11a.5.5 0 010 1zm0 2h-11a.5.5 0 010-1h11a.5.5 0 010 1zm0 2h-11a.5.5 0 010-1h11a.5.5 0 010 1z" fill="#C8C6C4"/>
        <path fill="#185ABD" d="M3.5 25h11a1.5 1.5 0 001.5-1.5v-11a1.5 1.5 0 00-1.5-1.5h-11A1.5 1.5 0 002 12.5v11A1.5 1.5 0 003.5 25z"/>
        <path fill="#F9F7F7" d="M7.215 20.73h.022C7.246 20.615 8.37 15 8.37 15h1.306s1.14 5.353 1.175 5.72h.017c.015-.252.944-5.72.944-5.72H13l-1.462 7h-1.389s-1.153-5.53-1.162-5.628h-.018C8.959 16.485 7.886 22 7.886 22h-1.41L5 15h1.21s1 5.607 1.005 5.73z"/>
    </svg>
)

export default class IconMSWord extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
